import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/JaPage.css';
import ReactGA from "react-ga4";

// Import images
import topBanner from '../images/top_banner.png';
import descriptionImage from '../images/en/description.png';

import mainShirtImage from '../images/shirt_one.jpg';
import leftImage from '../images/pc/left_image.png';
import rightImage from '../images/pc/right_image.jpg';
import rightLogo from '../images/pc/right_logo.svg';

import birdImage from '../images/bird.png';
import flowerImage from '../images/flower.png';
import itemBoxImage from '../images/item_01_box.png';
import leftButton from '../images/left_button.png';
import rightButton from '../images/right_button.png';
import sweaterImage from '../images/sweater.png';
import sweaterImage1 from '../images/sweater_1.png';
import sweaterImage2 from '../images/sweater_2.png';
import sweaterImage3 from '../images/sweater_3.png';

import umeImage from '../images/ume.png';
import tsuruImage from '../images/tsuru.png';
import itemBoxTwoImage from '../images/item_02_box.png';
import shirtImage from '../images/shirt.png';
import shirtImage1 from '../images/shirt_1.png';
import shirtImage2 from '../images/shirt_2.png';

import tsubakiImage from '../images/tsubaki.png';
import momijiImage from '../images/momiji.png';
import itemBoxThreeImage from '../images/item_03_box.png';
import toteImage from '../images/tote.png';
import toteImage1 from '../images/tote_1.png';
import toteImage2 from '../images/tote_2.png';
import toteImage3 from '../images/tote_3.png';

import hanafuda1 from '../images/hanafuda_1.png';
import hanafuda2 from '../images/hanafuda_2.png';
import ogataSan from '../images/ogata_san.jpg';
import ogataName from '../images/ogata_name.svg';
import ogataBackground from '../images/ogatasan_layer.png';
import bonsaiImage from '../images/bonsai.png';
import inoshishiImage from '../images/inoshishi.png';
import koiImage from '../images/koi.png';

import minashinoImage from '../images/minashino.png';
import amewoimisuruText from '../images/en/amewoimisuru.svg';
import hanafudaAmesankohImage from '../images/hanafuda-amesankoh.png';
import asanoyoroshiImage from '../images/asanoyorishi.png';

import momijiLayerImage from '../images/momiji_layer.png';
import kodawariText from '../images/en/kodawari.svg';
import shikaLayerImage from '../images/shika_layer.png';

const EnPage = () => {
  const sweaterImages = [sweaterImage, sweaterImage1, sweaterImage2, sweaterImage3];
  const shirtImages = [shirtImage, mainShirtImage, shirtImage1, shirtImage2];
  const toteImages = [toteImage, toteImage1, toteImage2, toteImage3];

  // State to track the current image index
  const [currentSweaterImageIndex, setCurrentSweaterImageIndex] = useState(0);
  const [currentShirtImageIndex, setCurrentShirtImageIndex] = useState(0);
  const [currentToteImageIndex, setCurrentToteImageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isTrackingAllowed, setIsTrackingAllowed] = useState(false);

  const allImages = [
    topBanner,
    descriptionImage,
    mainShirtImage,
    leftImage,
    rightImage,
    rightLogo,
    birdImage,
    flowerImage,
    itemBoxImage,
    leftButton,
    rightButton,
    ...sweaterImages,
    ...shirtImages,
    ...toteImages,
    umeImage,
    tsuruImage,
    itemBoxTwoImage,
    tsubakiImage,
    momijiImage,
    itemBoxThreeImage,
    hanafuda1,
    hanafuda2,
    ogataSan,
    ogataName,
    ogataBackground,
    bonsaiImage,
    inoshishiImage,
    koiImage,
    minashinoImage,
    amewoimisuruText,
    hanafudaAmesankohImage,
    asanoyoroshiImage,
    momijiLayerImage,
    kodawariText,
    shikaLayerImage,
  ];

  useEffect(() => {
    const loadImages = async () => {
      const imagePromises = allImages.map((src) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = reject;
        });
      });

      // Wait for all images to load
      await Promise.all(imagePromises);
      setIsLoading(false);
    };

    loadImages();
  }, []);


  // Function to navigate to the /ja route
  const toggleLanguage = () => {
    navigate('/ja');
  };

  const changeImage = (direction, currentIndex, setIndex, imagesArray) => {
    setIndex((prevIndex) => {
      if (direction === "next") {
        return prevIndex === imagesArray.length - 1 ? 0 : prevIndex + 1;
      } else {
        return prevIndex === 0 ? imagesArray.length - 1 : prevIndex - 1;
      }
    });
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(null);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = (currentIndex, setIndex, imagesArray) => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50;

    if (distance > minSwipeDistance) {
      changeImage("next", currentIndex, setIndex, imagesArray);
    } else if (distance < -minSwipeDistance) {
      changeImage("previous", currentIndex, setIndex, imagesArray);
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  if (isLoading) {
    return <div className="loading"></div>;
  }

  return (
    <div className="container">
      <div className="pc column">
        <div className="container-left">
          <img src={leftImage} alt="Left" className="left-image" />
          <div className="red-filter"></div>
        </div>
      </div>
      <div className="column center-column">
        <div className="sp-container">
          <button onClick={toggleLanguage} className="language-toggle-button">JP</button>
          <div className="top">
            <img src={topBanner} alt="Person" className="top-banner" />
          </div>
          <div className="main-image">
            <img src={mainShirtImage} alt="Main Shirt" className="shirt-image" />
          </div>
          <div className="first-description">
            <img src={descriptionImage} alt="Description" className="description-image" />
          </div>
          <div className="product-container">
            <img src={itemBoxImage} alt="Item Box" className="item-box" />
            <img src={rightButton} alt="Right Button" className="navigation-button left-button" onClick={() => changeImage("previous", currentSweaterImageIndex, setCurrentSweaterImageIndex, sweaterImages)} />
            <img src={leftButton} alt="Left Button" className="navigation-button right-button" onClick={() => changeImage("next", currentSweaterImageIndex, setCurrentSweaterImageIndex, sweaterImages)} />
            <div
              className="product-image-container"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={() => handleTouchEnd(currentSweaterImageIndex, setCurrentSweaterImageIndex, sweaterImages)}
            >
              <img src={sweaterImages[currentSweaterImageIndex]} alt="Sweater" className="product-image" />
            </div>
            <div className="product-details">
              <span className="product-name">Sweater</span>
              <span className="product-price">64,00€</span>
            </div>
            <a href="https://amesankoh.com/products/ogata-x-amesankoh-sweater" className="purchase-button">SHOP NOW</a>
            <img src={birdImage} alt="Bird Decoration" className="decoration bird-and-tsubaki-decoration" />
            <img src={flowerImage} alt="Flower Decoration" className="decoration flower-decoration" />
          </div>
          <div className="product-container">
            <img src={itemBoxTwoImage} alt="Item Box" className="item-box" />
            <img src={rightButton} alt="Right Button" className="navigation-button left-button" onClick={() => changeImage("previous", currentShirtImageIndex, setCurrentShirtImageIndex, shirtImages)} />
            <img src={leftButton} alt="Left Button" className="navigation-button right-button" onClick={() => changeImage("next", currentShirtImageIndex, setCurrentShirtImageIndex, shirtImages)} />
            <div
              className="product-image-container"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={() => handleTouchEnd(currentShirtImageIndex, setCurrentShirtImageIndex, shirtImages)}
            >
              <img src={shirtImages[currentShirtImageIndex]} alt="Shirt" className="product-image" />
            </div>
            <div className="product-details">
              <span className="product-name">Tshirts</span>
              <span className="product-price">42,00€</span>
            </div>
            <a href="https://amesankoh.com/products/ogata-x-amesankoh-tshirts" className="purchase-button">SHOP NOW</a>
            <img src={umeImage} alt="Ume Decoration" className="decoration ume-decoration" />
            <img src={tsuruImage} alt="Tsuru Decoration" className="decoration flower-decoration" />
          </div>
          <div className="product-container">
            <img src={itemBoxThreeImage} alt="Item Box" className="item-box" />
            <img src={rightButton} alt="Right Button" className="navigation-button left-button" onClick={() => changeImage("previous", currentToteImageIndex, setCurrentToteImageIndex, toteImages)} />
            <img src={leftButton} alt="Left Button" className="navigation-button right-button" onClick={() => changeImage("next", currentToteImageIndex, setCurrentToteImageIndex, toteImages)} />
            <div
              className="product-image-container"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={() => handleTouchEnd(currentToteImageIndex, setCurrentToteImageIndex, toteImages)}
            >
              <img src={toteImages[currentToteImageIndex]} alt="Tote" className="product-image" />
            </div>
            <div className="product-details">
              <span className="product-name">Totebag</span>
              <span className="product-price">10,00€</span>
            </div>
            <a href="https://amesankoh.com/products/ogata-x-amesankoh-totebag" className="purchase-button">SHOP NOW</a>
            <img src={tsubakiImage} alt="Ume Decoration" className="decoration bird-and-tsubaki-decoration" />
            <img src={momijiImage} alt="Tsuru Decoration" className="decoration flower-decoration" />
          </div>
          <div className="about-ogata">
            <img src={ogataBackground} alt="Background Decoration" className="background-decoration" />
            <img src={ogataName} alt="Ogata Name" className="ogata-name" />
            <div className="ogata-content">
              <img src={ogataSan} alt="Ogata-san" className="ogata-photo" />
              <div className="hanafuda-decorations">
                <img src={hanafuda1} alt="Hanafuda 1" className="hanafuda-card" />
                <img src={hanafuda2} alt="Hanafuda 2" className="hanafuda-card" />
              </div>
              <div className="description">
                <p className="description-text">
                  Moved to Germany in 2000. Became independent in 2007 and has since been active as an illustrator and graphic designer based in Dusseldorf. <br></br>
                  Currently, while showcasing his own illustration works, he participates in various projects as an illustrator and graphic designer.
                </p>
              </div>
              <div className="ogata-bottom">
                <img src={koiImage} alt="Koi" className="artwork koi" />
                <img src={bonsaiImage} alt="Bonsai" className="artwork bonsai" />
                <img src={inoshishiImage} alt="Inoshishi" className="inoshishi" />
              </div>
            </div>
          </div>
          <div className="about-amesankoh">
            <img src={minashinoImage} alt="Background Decoration" className="minashino-decoration" />
            <img src={amewoimisuruText} alt="Ogata Name" className="ogata-name" />
            <div className="ogata-content">
              <img src={hanafudaAmesankohImage} alt="Ogata-san" className="amesankoh-hanafuda-photo" />
              <div className="description">
                <p className="description-text">
                  One of the light cards in Hanafuda is 'Yanagi ni Ono no Michikaze.' Michikaze, who struggled with his talent and was about to give up on calligraphy, was inspired by the sight of a frog that continued to challenge itself by trying to leap onto the willow.
                  After seeing the frog succeed with the help of a gust of wind, he realized he had not put in enough effort and decided to start practicing calligraphy again. This story is the origin of the illustration on this Hanafuda card.
                </p>
              </div>
              <div className="about-amesankoh-bottom">
                <iframe
                  src="https://www.youtube.com/embed/NK1rMEtWJfs"
                  title="YouTube video player"
                  className="video koi-video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <img src={asanoyoroshiImage} alt="Asanoyoroshi" className="asanoyoroshi" />
              </div>
            </div>
          </div>
          <div className="kodawari-amesankoh">
            <img src={momijiLayerImage} alt="Background Decoration" className="minashino-decoration" />
            <img src={kodawariText} alt="Ogata Name" className="kodawari-name" />
            <div className="ogata-content">
              <iframe
                src="https://www.youtube.com/embed/jiEbj1A2un4"
                title="YouTube video player"
                className="video koi-video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <div className="description">
                <p className="description-text">
                  In order to capture Takumi Ogata's intricate designs in print, we decided to use screen printing for a large back print this time.
                  The t-shirts feature three colors, emphasizing the contrast between green and pink to highlight their cuteness!
                  For the sweaters, we designed them to showcase strength and impact with a vintage feel, ensuring that the ink seeps into the fibers after washing.
                </p>
              </div>
              <div className="kodawari-bottom">
                <img src={shikaLayerImage} alt="Shika" className="inoshishi" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pc column">
        <div className="container-right">
          <img src={rightImage} alt="Right" className="right-image" />
          <div className="red-filter"></div>
          <img src={rightLogo} alt="Right Logo" className="right-logo" />
        </div>
      </div>
    </div>
  );
}

export default EnPage;
